// 지점 직접결제: 서버가 check·pay-start 응답으로 {mode:'DIRECT', checkoutUrl} 을 주면 포트원(IMP) 대신 서버 결제창으로 이동한다.
// 요청에 실은 returnPath(이 매장 단축 주소)로 서버가 `/<경로>#/result?moid=&result=` 에 직접 303 한다.
// 서버가 경로를 못 쓰면 고정 주소(public/pg-direct-done.html)로 보내므로, 떠나기 전 경로·방 번호를 같은 출처에 남겨 둔다.
// 주문별 키 — 두 탭에서 동시에 결제해도 서로의 복귀 기록을 덮어쓰지 않는다.
export const returnKey = moid => `pgDirectReturn:${moid}`;
const RETURN_TTL_MS = 24 * 60 * 60 * 1000;
const RESULTS = ['success', 'fail', 'pending', 'cancel'];

export const isDirect = data => data?.mode === 'DIRECT';

// 빌드 플래그가 켜진 빌드만 싣는다 — returnPath 를 모르는 서버는 이 키 때문에 예약 요청을 400 으로 거부한다(서버 먼저 배포).
// 서버 검증(^[0-9A-Za-z-]{1,64}$)에 안 맞는 주소(로컬·직접 진입 등)도 같은 이유로 싣지 않는다.
export function returnPath(location = window.location) {
    if (process.env.REACT_APP_PG_DIRECT !== 'true') return undefined;
    const path = String(location.pathname).replace(/^\//, '');
    return /^[0-9A-Za-z-]{1,64}$/.test(path) ? path : undefined;
}

export function openDirectCheckout({checkoutUrl, moid, stNo}) {
    if (typeof checkoutUrl !== 'string' || !/^https:\/\//.test(checkoutUrl)) throw new Error('결제창 주소가 없습니다.');
    localStorage.setItem(returnKey(moid), JSON.stringify({moid, path: window.location.pathname.replace(/^\//, ''), at: Date.now(), ...(stNo != null ? {stNo} : {})}));
    window.location.assign(checkoutUrl);
}

export function savedDirectReturn(moid) {
    try {
        const saved = JSON.parse(localStorage.getItem(returnKey(moid)));
        return saved?.moid === moid ? saved : null;
    } catch {
        return null;
    }
}

// 결과가 서버에서 확정되면(paid·failed·cancelled, 묶음 confirmed·released) 그 주문의 기록은 더 쓸 일이 없다.
export function forgetDirectReturn(moid) {
    try { localStorage.removeItem(returnKey(moid)); } catch { /* 저장소를 못 쓰면 지울 것도 없다 */ }
}

// 확정을 못 본 채 떠난 기록은 결과 화면 진입 때 24시간 기준으로 정리한다. 시각이 없거나 읽을 수 없는 기록도 지운다.
export function pruneDirectReturns(now = Date.now()) {
    try {
        Object.keys(localStorage).filter(key => key.startsWith('pgDirectReturn:')).forEach(key => {
            let at;
            try { at = Number(JSON.parse(localStorage.getItem(key))?.at); } catch { at = NaN; }
            if (!(now - at < RETURN_TTL_MS)) localStorage.removeItem(key);
        });
    } catch { /* 저장소를 못 쓰면 정리할 것도 없다 */ }
}

export function readDirectReturn(location = window.location) {
    const params = new URLSearchParams(location.search);
    const hashParams = new URLSearchParams(String(location.hash).split('?')[1]);
    const value = key => params.get(key) ?? hashParams.get(key);
    const moid = value('moid');
    const result = value('result');
    if (!moid || !RESULTS.includes(result)) return null;
    return {moid, result};
}
